/**
 * État d'un JobStepUserResult
 */
export enum JobStepUserResultStateEnum {
  ToBeTreated = 0,
  WorkInProgress = 1,
  Done = 2,
  OnError = 3,
}
